import BasicForm from './BasicForm';

/**
 * @description Base button implementation
 */
export default class Form extends BasicForm {

}
